"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MouseEnvironmentActivation = void 0;
/* eslint-disable class-methods-use-this */
const Activation_1 = require("./Activation");
class MouseEnvironmentActivation extends Activation_1.Activation {
    mouseEntered() {
        // Do nothing
    }
    mouseMoved() {
        // Do nothing
    }
    mouseLeft() {
        // Do nothing
    }
    mouseClicked() {
        // Do nothing
    }
}
exports.MouseEnvironmentActivation = MouseEnvironmentActivation;
//# sourceMappingURL=MouseEnvironmentActivation.js.map